import { Timestamp } from "firebase/firestore";

/**
 * Bar Status Enum
 */
export enum BarStatus {
  ACTIVE = "active",
  CLOSED = "closed",
  ARCHIVED = "archived",
}

/**
 * Bar Visibility Enum
 */
export enum BarVisibility {
  PUBLIC = "public",
  UNLISTED = "unlisted",
}

/**
 * Contact Information
 */
export interface Contact {
  phone?: string;
  email?: string;
  website?: string;
}

/**
 * Social Media Links
 */
export interface Socials {
  instagram?: string;
  facebook?: string;
  twitter?: string;
}

/**
 * Operating Hours
 */
export interface OperatingHours {
  monday?: string;
  tuesday?: string;
  wednesday?: string;
  thursday?: string;
  friday?: string;
  saturday?: string;
  sunday?: string;
}

/**
 * GeoPoint for Location
 */
export interface GeoPoint {
  latitude: number;
  longitude: number;
}

export interface AddressDetails {
  street?: string;
  housenumber?: string;
  city?: string;
  postcode?: string;
  country?: string;
}

/**
 * Bar Interface (Main bar document)
 */
export interface Bar {
  id: string;
  osmId?: string;
  name: string;
  description?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  geohash?: string;
  location?: GeoPoint;
  addressDetails?: AddressDetails;
  source?: string;
  sourceSuggestionId?: string;
  sourceSuggestionStatus?: string;
  importedFromSuggestion?: boolean;

  // Owner & Claims
  ownerId?: string;
  ownerName?: string;
  ownerEmail?: string;
  isClaimed: boolean;
  claimedAt?: Timestamp;

  // Verification & Status
  isVerified: boolean;
  verifiedAt?: Timestamp;
  verifiedBy?: string; // Admin UID
  status: BarStatus;
  visibility: BarVisibility;

  // Contact & Socials
  contact?: Contact;
  socials?: Socials;
  operatingHours?: OperatingHours;

  // Media
  photoUrl?: string;
  coverPhotoUrl?: string;
  photos?: string[];

  // Metadata
  viewCount?: number;
  favoriteCount?: number;
  drinkCount?: number;
  eventCount?: number;
  offerCount?: number;

  // Tags & Categories
  tags?: string[];
  categories?: string[];
  audiences?: string[];
  atmospheres?: string[];

  // Timestamps
  createdAt: Timestamp;
  updatedAt: Timestamp;
  lastActivityAt?: Timestamp;
}
